// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0abcbb39","788":"d9b55ce3","847":"a454f2b5","956":"94faa786"}[chunkId] + ".chunk.js";
};